import styled from 'styled-components'
import { customMedia } from '../../utils/breakpoints'

export const VirtualAssistant = styled.iframe`
  
`
export const MaximizeVirtualAssistant = styled.div`
  position: fixed;
  z-index: 1100;  
  right: ${props => props.showChat ? '95px' : '24px'};
  bottom: ${props => props.showChat ? '418px' : '40px'};

  ${customMedia.lessThan('xs')`
    right: 16px;
    top: ${props => props.showChat ? '8px' : ''};
    bottom: ${props => props.showChat ? '' : '72px'};
  `}
`

export const MaximizeButton = styled.button`
  width: 48px;
  height: 48px;
  float: right;
  background-color: #002A3E;
  color: #fff;  
  border-radius: 50px;
  text-align: center;
`

export const MinimizeButton = styled.button`
  width: 48px;
  height: 48px;
  float: right;
  background-color: #000E40;
  color: #fff;  
  border-radius: 50px;
  text-align: center;
`

export const VirtualAssistantIcon = styled.img`

`